import React from "react";
import Select from "react-select";
import { useField, useFormikContext } from "formik";

const CustomSelect = ({ label, options, ...props }) => {
  const [field, meta] = useField(props);
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
      boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.15)" : "0 1px 2px rgba(0, 0, 0, 0.03)",
      padding: "2px 8px",
      fontSize: "0.95rem",
      backgroundColor: "#ffffff",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? "#ffc107" 
        : state.isFocused 
        ? "rgba(255, 193, 7, 0.1)" 
        : "#fff",
      color: state.isSelected ? "#000" : "#1e293b",
      padding: "10px 15px",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#ffc107",
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "12px",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
      overflow: "hidden",
      border: "1px solid #e2e8f0",
      zIndex: 9999,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1e293b",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#94a3b8",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#64748b",
      "&:hover": {
        color: "#1e293b",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const onChange = (option) => {
    setFieldValue(props.name, option ? option.value : "");
  };

  const getValue = () => {
    if (options) {
      return options.find((option) => option.value === field.value);
    } else {
      return "";
    }
  };

  return (
    <div className="form-group mb-0">
      {label && <label className="mb-2 d-block">{label}</label>}
      <Select
        {...field}
        {...props}
        options={options}
        value={getValue()}
        onChange={onChange}
        onBlur={() => setFieldTouched(props.name, true)}
        styles={customStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        classNamePrefix="custom-select"
        placeholder={props.placeholder || "Select..."}
      />
      {meta.touched && meta.error ? (
        <div className="invalid-feedback d-block mt-2">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default CustomSelect;
